import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Page, AppProvider } from '@shopify/polaris';
import translations from '@shopify/polaris/locales/es.json'

import { tModel } from '@utils';

const propTypes = {
  warranty: PropTypes.object.isRequired,
};


const WarrantyShow = ({ warranty }) => (
  <AppProvider i18n={translations}>
    <Page
      title={ tModel("warranty") }
      primaryAction={{ content: 'Create warranty' }}
    >
      <p>
        Content of the Warranty.
      </p>
      <p>
        Name: { warranty.name }
      </p>
      <p>
        Tag: { warranty.tag }
      </p>
    </Page>
  </AppProvider>
)


WarrantyShow.propTypes = propTypes;


export default WarrantyShow;
